import { Quote } from "lucide-react";

// Fully-anonymous director feedback gathered during product-discovery calls.
// We intentionally DO NOT publish real names, centers, or photos of our
// design-partner directors. Each quote is kept generic at the role + county
// level to honour their privacy and avoid any misleading endorsement claim.
const quotes = [
  {
    quote:
      "Having every DCY 01234 signed, dated, and filed in one place changed how we walk into inspections. We stopped worrying about binders.",
    attribution: "A director in Franklin County · licensed for 52",
  },
  {
    quote:
      "GPS clock-in for teachers and live ratios on my phone mean I'm not driving between centers with a clipboard anymore.",
    attribution: "A 3-location owner in the Miami Valley",
  },
  {
    quote:
      "Billing reconciliation used to eat a full weekend every month. ChildCheck turned it into a Monday-morning coffee break.",
    attribution: "An administrator in Hamilton County",
  },
];

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-emerald-700">
            Voices from the field
          </div>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl font-medium text-stone-900 tracking-tight">
            Directors who traded paper for peace.
          </h2>
          <p className="mt-3 text-sm text-stone-600 max-w-xl">
            Anonymous feedback from licensed Ohio directors we partner with during
            product design. Names and centers withheld by request.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {quotes.map((q, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className={`relative rounded-2xl border border-stone-200 bg-stone-50 p-7 flex flex-col gap-5 hover:-translate-y-1 transition-all hover:shadow-lift ${
                i === 1 ? "md:translate-y-8" : ""
              }`}
            >
              <Quote className="w-6 h-6 text-emerald-700/40" />
              <blockquote className="font-display text-lg text-stone-800 leading-snug">
                “{q.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-4 border-t border-stone-200">
                <div className="text-xs text-stone-500 font-medium italic">{q.attribution}</div>
              </figcaption>
            </figure>
          ))}
        </div>
        <p className="mt-8 text-[11px] text-stone-400">
          ChildCheckOh is independent software. Nothing on this page is an endorsement by
          any government agency. All quotes are anonymised and shared with the
          director's written consent.
        </p>
      </div>
    </section>
  );
};

export default Testimonials;
